require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-ml-trends-neurips-2019.json") })
        }
      }, "path---posts-ml-trends-neurips-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-ml-trends-neurips-2019!./.cache/json/posts-ml-trends-neurips-2019.json
// module id = 396
// module chunks = 231608221292675